module.exports = __webpack_public_path__ + "img/booklet.08ff6806.svg";